import { render, staticRenderFns } from "./BadgeTitleItems.vue?vue&type=template&id=101e7aaf&"
import script from "./BadgeTitleItems.vue?vue&type=script&lang=js&"
export * from "./BadgeTitleItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports